/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * First-touch acquisition params captured by the frontend at signup.
 *
 * All fields optional and bounded; unknown keys are ignored. Values are
 * persisted verbatim (they are our own marketing params, not rendered
 * HTML) and flattened into analytics identify traits.
 */
export interface SignupAttributionRequest {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_term?: string | null;
  utm_content?: string | null;
  gclid?: string | null;
  fbclid?: string | null;
  referrer?: string | null;
  landing_page?: string | null;
  comet_token?: string | null;
}
